import { eCommentType } from '../comment/eCommentType';

export enum eVendorServiceType {
  titleSearchRequest = 'title_search',
  payoffRequest = 'payoff',
  taxCertificationRequest = 'tax_certification',
}

export const vendorServiceTypeCommentType: Record<eVendorServiceType, eCommentType> = {
  [eVendorServiceType.titleSearchRequest]: eCommentType.titleSearch,
  [eVendorServiceType.payoffRequest]: eCommentType.payoff,
  [eVendorServiceType.taxCertificationRequest]: eCommentType.taxCertification,
};
